let fbpixelTrackingId = null;

export const fbInit = (trackingId) => {
    if (window.fbq)
        return;
    fbpixelTrackingId = trackingId;

    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script');

    fbq('init', fbpixelTrackingId);
    fbq('track', 'PageView');
};

export const fbPixelOrder = (params = {}, eventId = null) => {
    if (typeof fbq !== 'function') {
        console.warn('Facebook Pixel is not available yet!');
        return;
    }
    if (eventId) {
        fbq('track', "Purchase", params, { eventID: eventId });
    } else {
        fbq('track', "Purchase", params);
    }
};


export const fbTrackPageView = () => {
    if (window.fbq)
        window.fbq('track', 'PageView');
};